import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ch-left",
  "use": "icon-ch-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevrons-left\" id=\"icon-ch-left\"><polyline points=\"11 17 6 12 11 7\" /><polyline points=\"18 17 13 12 18 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol